import * as actions from '../actions/questionAnswersRevisions';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestQuestionAnswerRevisions(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.FETCH_QUESTION_ANSWER_REVISIONS)
        .map(action => ({
            url: BASE_URL
                + `api/Applications/${action.payload.applicationId}/answers/${action.payload.editingSettingId}/revisions/${action.payload.entityId}`,
            category: 'requestQuestionAnswerRevisions',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestQuestionAnswerRevisions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.fetchQuestionAnswerRevisionsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestQuestionAnswerRevisionsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestQuestionAnswerRevisions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.fetchQuestionAnswerRevisionsFailed(response));

    return {
        ACTION: httpResponse$
    };
}